module.exports = __webpack_public_path__ + "img/Ellipse7.cd5838f1.png";